import {TrainingSpecialitiesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_TRAINING_SPECIALITIES';

export async function getAllTrainingSpecialities(
    userData: UserState["userProfileData"],
    params: string,
    page: number
) {
    try {

        return await TrainingSpecialitiesDao.getAllTrainingSpecialities(userData?.userToken as string, params, page);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des spécialités de la formation',
            error: error
        });
    }
}
